export default __webpack_public_path__ + "static/media/envelope-alt.d0cb38b7.svg";